<main class="main main-marketplace">
  @if (creatures && ((creatures.length != 0 || !onlyMy) || (creatures.length == 0 || onlyMy))) {
  <section class="list marketplace">
    <div class="container">
      <div class="list__header">
        <!-- Breeding Orders Badge -->
        <div class="breeding-orders-badge" 
             *ngIf="onlyMy && breedingOrderCount && breedingOrderCount > 0"
             [routerLink]="['/', lang, 'my-creatures', 'breeding']"
             title="Go to breeding page">
          <span class="breeding-text">{{ 'list_creature.breeding_orders' | translate }}</span>
          <span class="breeding-count">{{breedingOrderCount}}</span>
        </div>
        
        <button class="list__header-filter" (click)="showMobileFilter = !showMobileFilter">
          <span>
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0 1C0 0.447715 0.447715 0 1 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H1C0.447715 2 0 1.55228 0 1ZM2 6C2 5.44772 2.44772 5 3 5H13C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7H3C2.44772 7 2 6.55228 2 6ZM5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H5Z"
                fill="white" />
            </svg>
          </span>
          {{ 'list_creature.header.filters' | translate }}
          <span class="num" *ngIf="countOfFilterChanged > 0">{{countOfFilterChanged}}</span>
        </button>
        <button class="list__header-prise" style="width: 180px;"><span>
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.3335 0.166504C10.5545 0.166504 10.7665 0.254301 10.9228 0.410582C11.079 0.566862 11.1668 0.778823 11.1668 0.999837V8.98817L12.2443 7.91067C12.4015 7.75887 12.612 7.67488 12.8305 7.67678C13.049 7.67867 13.258 7.76631 13.4125 7.92082C13.567 8.07533 13.6547 8.28434 13.6566 8.50284C13.6585 8.72133 13.5745 8.93184 13.4227 9.089L10.9227 11.589C10.7664 11.7452 10.5545 11.833 10.3335 11.833C10.1125 11.833 9.90062 11.7452 9.74434 11.589L7.24434 9.089C7.09255 8.93184 7.00855 8.72133 7.01045 8.50284C7.01235 8.28434 7.09999 8.07533 7.25449 7.92082C7.409 7.76631 7.61801 7.67867 7.83651 7.67678C8.05501 7.67488 8.26551 7.75887 8.42268 7.91067L9.50018 8.98817V0.999837C9.50018 0.778823 9.58797 0.566862 9.74425 0.410582C9.90053 0.254301 10.1125 0.166504 10.3335 0.166504ZM3.07768 0.410671C3.23395 0.254445 3.44587 0.166682 3.66684 0.166682C3.88781 0.166682 4.09974 0.254445 4.25601 0.410671L6.75601 2.91067C6.90781 3.06784 6.9918 3.27834 6.9899 3.49684C6.98801 3.71534 6.90037 3.92435 6.74586 4.07885C6.59135 4.23336 6.38234 4.321 6.16384 4.3229C5.94535 4.3248 5.73485 4.2408 5.57768 4.089L4.50018 3.0115V10.9998C4.50018 11.2209 4.41238 11.4328 4.2561 11.5891C4.09982 11.7454 3.88786 11.8332 3.66684 11.8332C3.44583 11.8332 3.23387 11.7454 3.07759 11.5891C2.92131 11.4328 2.83351 11.2209 2.83351 10.9998V3.0115L1.75601 4.089C1.59884 4.2408 1.38834 4.3248 1.16984 4.3229C0.951345 4.321 0.742335 4.23336 0.587828 4.07885C0.433321 3.92435 0.34568 3.71534 0.343782 3.49684C0.341883 3.27834 0.425878 3.06784 0.577677 2.91067L3.07768 0.410671Z"
                fill="white" />
            </svg>
          </span>
          <div>{{filter.sortBy | creatureSortType | translate}}</div>
          <div class="sort_by__list">
            <div class="sort_by__item" (click)="filter.sortBy = sortType.PriceAsc; onFilterChange()">
              {{ 'list_creature.sort_options.price' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.PriceDesc; onFilterChange()">
              {{ 'list_creature.sort_options.price_desc' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.RarityAsc; onFilterChange()">
              {{ 'list_creature.sort_options.rarity' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.RarityDesc; onFilterChange()">
              {{ 'list_creature.sort_options.rarity_desc' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.LevelAsc; onFilterChange()">
              {{ 'list_creature.sort_options.level' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.LevelDesc; onFilterChange()">
              {{ 'list_creature.sort_options.level_desc' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.HpAsc; onFilterChange()">
              {{ 'list_creature.sort_options.hp' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.HpDesc; onFilterChange()">
              {{ 'list_creature.sort_options.hp_desc' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.TokenIdAsc; onFilterChange()">
              {{ 'list_creature.sort_options.token_id' | translate }}
            </div>
            <div class="sort_by__item" (click)="filter.sortBy = sortType.TokenIdDesc; onFilterChange()">
              {{ 'list_creature.sort_options.token_id_desc' | translate }}
            </div>
          </div>
        </button>
      </div>
      <div class="marketplace__inner">

        <filter-creature-component [(filter)]="filter" [(showMobile)]="showMobileFilter"
          (filterChange)="onFilterChange()" (showMobileChange)="onCloseMobileFilter()"></filter-creature-component>

        <div class="list__inner" (scroll)="onScroll($event)" style="overflow-y: auto; max-height: 70vh;">
          @for (creature of creatures; track creature) {
          <div class="list__item">
            <div class="list__card">
              <a [routerLink]="['/', lang, onlyMy ? 'my-creatures' : 'marketplace','view', creature.id]">
                <item-creature-component [creature]="creature"></item-creature-component>
              </a>
            </div>
          </div>
          }
        </div>

      </div>
    </div>
  </section>
  } @else if (creatures && creatures.length == 0) {
  <empty-page-component></empty-page-component>
  } @else {
  @if (onlyMy){
  <section *ngIf="showLoading" class="loader-box">
    <span class="loader"></span>
  </section>
  }
  @else {
  <section class="list marketplace loading">
    <div class="container">
      <span class="loader"></span>
    </div>
  </section>
  }
  }
</main>